<template>
  <beer itemId="2000000006" itemName="smash" title="Smash, 14 °P, Smash APA">
    <p
      style="
          margin: auto;
          text-align: justify;
          max-width: 40rem;
          width: 100%;
          margin-top: 4rem;
        "
    >
      Jednoduché přímočaré pivo, které dává možnost vyniknout námi velice oblíbenému chmelu Mosaic. Díky
      použití moderních metod studeného chmelení jsme získali skvělé aroma, ve kterém jsou cítit tóny citrusů, borůvek a
      mučenky. Chmelové aroma a chuť se krásně doplňuje s plným tělem piva.
    </p>

    <table
      class="tg"
      style="
          margin: auto;
          text-align: left;
          max-width: 40rem;
          width: 100%;
          margin-top: 4rem;
        "
    >
      <tbody>
        <tr>
          <td class="bold">Pivní styl</td>
          <td class="right">Smash APA</td>
        </tr>
        <tr>
          <td>Stupňovitost</td>
          <td class="right">14 °P</td>
        </tr>
        <tr>
          <td>Alkohol</td>
          <td class="right">5,8 %</td>
        </tr>
        <tr>
          <td>Barva</td>
          <td class="right">4,7 SRM</td>
        </tr>
        <tr>
          <td>Hořkost</td>
          <td class="right">38 IBU</td>
        </tr>
        <tr>
          <td>Slady</td>
          <td class="right">pale ale</td>
        </tr>
        <tr>
          <td>Chmely</td>
          <td class="right">Mosaic</td>
        </tr>
      </tbody>
    </table>
  </beer>
</template>

<script>
import Beer from "../Beer";
export default {
  name: "Smash",
  components: { Beer },
};
</script>
